import * as Sentry from "@sentry/react"
Sentry.init({
	sendDefaultPii: true,
	dsn: "https://3fcf9b429664d1577a4db5c7733b8cd6@o4510737314742272.ingest.de.sentry.io/4510742524198992",
	denyUrls: [
		// Third-party scripts (browser extensions, injected code)
		/profitwell\.com/i,
		/extensions\//i,
		/^chrome:\/\//i,
		/^chrome-extension:\/\//i,
		/^moz-extension:\/\//i,
	],
})
